"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewBusinessSummaryOrderBy = exports.UpcomingRenewalsSummaryOrderBy = exports.ClientSummaryOrderBy = exports.AffinityGroup = exports.VerificationStatus = exports.ARCHIVE_ACCOUNT_STATUS_REASONS = exports.AccountStatusReason = exports.AccountStatus = exports.legalEntityTypeValues = exports.LegalEntityType = exports.BrokerOfRecord = exports.AccountType = exports.AccountsOrderBy = void 0;
const omit_1 = __importDefault(require("lodash/omit"));
var AccountsOrderBy;
(function (AccountsOrderBy) {
    AccountsOrderBy["CREATED_AT"] = "CREATED_AT";
    AccountsOrderBy["UPDATED_AT"] = "UPDATED_AT";
})(AccountsOrderBy = exports.AccountsOrderBy || (exports.AccountsOrderBy = {}));
var AccountType;
(function (AccountType) {
    AccountType["COMMERCIAL"] = "commercial";
    AccountType["PERSONAL"] = "personal";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
/**
 * Agent designated by the policyholder to represent and manage a policyholder's insurance
 */
var BrokerOfRecord;
(function (BrokerOfRecord) {
    BrokerOfRecord["NEWFRONT"] = "NEWFRONT";
    BrokerOfRecord["MSO"] = "MSO";
})(BrokerOfRecord = exports.BrokerOfRecord || (exports.BrokerOfRecord = {}));
var LegalEntityType;
(function (LegalEntityType) {
    LegalEntityType["C_CORPORATION"] = "C-corporation";
    LegalEntityType["GOVERNMENT_ENTITY"] = "Government entity";
    LegalEntityType["INDEPENDENT_CONTRACTOR"] = "Independent contractor";
    LegalEntityType["JOINT_VENTURE"] = "Joint Venture";
    LegalEntityType["LLC"] = "LLC";
    LegalEntityType["NOT_FOR_PROFIT"] = "Not-for-profit";
    LegalEntityType["OTHER"] = "Other";
    LegalEntityType["PARTNERSHIP"] = "Partnership";
    LegalEntityType["PROPRIETORSHIP"] = "Proprietorship";
    LegalEntityType["S_CORPORATION"] = "S-corporation";
    LegalEntityType["TRUST"] = "Trust";
    LegalEntityType["UNINCORPORATED_ASSOCIATION"] = "Unincorporated association";
})(LegalEntityType = exports.LegalEntityType || (exports.LegalEntityType = {}));
exports.legalEntityTypeValues = Object.values(LegalEntityType);
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["ARCHIVED"] = "ARCHIVED";
    AccountStatus["MERGED"] = "MERGED";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AccountStatusReason;
(function (AccountStatusReason) {
    AccountStatusReason["CLIENT_DECLINED_PROPOSAL"] = "CLIENT_DECLINED_PROPOSAL";
    AccountStatusReason["CLIENT_OUT_OF_BUSINESS"] = "CLIENT_OUT_OF_BUSINESS";
    AccountStatusReason["CLIENT_UNINSURABLE"] = "CLIENT_UNINSURABLE";
    AccountStatusReason["CLIENT_UNRESPONSIVE"] = "CLIENT_UNRESPONSIVE";
    AccountStatusReason["CREATED"] = "CREATED";
    AccountStatusReason["DUPLICATE_OR_ERROR"] = "DUPLICATE_OR_ERROR";
    AccountStatusReason["MIGRATED"] = "MIGRATED";
    AccountStatusReason["NF_ENDED_RELATIONSHIP"] = "NF_ENDED_RELATIONSHIP";
    AccountStatusReason["UNARCHIVED"] = "UNARCHIVED";
})(AccountStatusReason = exports.AccountStatusReason || (exports.AccountStatusReason = {}));
exports.ARCHIVE_ACCOUNT_STATUS_REASONS = (0, omit_1.default)(AccountStatusReason, [
    AccountStatusReason.CREATED,
    AccountStatusReason.UNARCHIVED,
]);
var VerificationStatus;
(function (VerificationStatus) {
    /**
     * The account does not have all of the data that the operations team requires, or there is
     * another account with the same data that was verified first.
     */
    VerificationStatus["NONE"] = "NONE";
    /**
     * Reserved only for migrating data from nf-app clients. nf-app clients that should be verified
     * accounts in this service because they already have quotes/policies, but do not yet have the
     * required data to be considered as verified will use this status temporarily while it is being
     * collected.
     */
    VerificationStatus["PENDING"] = "PENDING";
    /**
     * The account has all of the data that the operations team requires, and also its
     * countryCode/businessIdentifier pair is unique between those (CL) or <TODO> (PL).
     */
    VerificationStatus["VERIFIED"] = "VERIFIED";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
var AffinityGroup;
(function (AffinityGroup) {
    AffinityGroup["AIA"] = "AIA";
    AffinityGroup["HOA_RELATED_BUSINESS"] = "HOA_RELATED_BUSINESS";
    AffinityGroup["PHYSICIANS"] = "PHYSICIANS";
    AffinityGroup["WEED_CLUB"] = "WEED_CLUB";
    AffinityGroup["Y_COMBINATOR"] = "Y_COMBINATOR";
})(AffinityGroup = exports.AffinityGroup || (exports.AffinityGroup = {}));
var ClientSummaryOrderBy;
(function (ClientSummaryOrderBy) {
    ClientSummaryOrderBy["NAME"] = "NAME";
    ClientSummaryOrderBy["FOLLOWUP_DATE"] = "FOLLOWUP_DATE";
    ClientSummaryOrderBy["NET_WORTH"] = "NET_WORTH";
    ClientSummaryOrderBy["CLOSEST_RENEWAL_DATE"] = "CLOSEST_RENEWAL_DATE";
})(ClientSummaryOrderBy = exports.ClientSummaryOrderBy || (exports.ClientSummaryOrderBy = {}));
var UpcomingRenewalsSummaryOrderBy;
(function (UpcomingRenewalsSummaryOrderBy) {
    UpcomingRenewalsSummaryOrderBy["NAME"] = "NAME";
    UpcomingRenewalsSummaryOrderBy["FOLLOWUP_DATE"] = "FOLLOWUP_DATE";
    UpcomingRenewalsSummaryOrderBy["NET_WORTH"] = "NET_WORTH";
    UpcomingRenewalsSummaryOrderBy["CLOSEST_RENEWAL_DATE"] = "CLOSEST_RENEWAL_DATE";
})(UpcomingRenewalsSummaryOrderBy = exports.UpcomingRenewalsSummaryOrderBy || (exports.UpcomingRenewalsSummaryOrderBy = {}));
var NewBusinessSummaryOrderBy;
(function (NewBusinessSummaryOrderBy) {
    NewBusinessSummaryOrderBy["NAME"] = "NAME";
    NewBusinessSummaryOrderBy["FOLLOWUP_DATE"] = "FOLLOWUP_DATE";
    NewBusinessSummaryOrderBy["LATEST_QUOTING_PLAN"] = "LATEST_QUOTING_PLAN";
    NewBusinessSummaryOrderBy["TARGET_PREMIUM"] = "TARGET_PREMIUM";
    NewBusinessSummaryOrderBy["PROPOSAL_DUE_DATE"] = "PROPOSAL_DUE_DATE";
    NewBusinessSummaryOrderBy["EARLIEST_EFFECTIVE_DATE"] = "EARLIEST_EFFECTIVE_DATE";
})(NewBusinessSummaryOrderBy = exports.NewBusinessSummaryOrderBy || (exports.NewBusinessSummaryOrderBy = {}));
//# sourceMappingURL=account.js.map